import React from "react";
import { Part1 } from "../components/Blog/Part1";
import { Part2 } from "../components/Blog/Part2";
import { Part3 } from "../components/Blog/Part3";
import { Part4 } from "../components/Blog/Part4";
import { Part5 } from "../components/Blog/Part5";
import { Part6 } from "../components/Blog/Part6";
import Footer from "../components/prakash/Components/Footer/Footer";
import Navbar from "../components/prakash/Components/Navbar/Navbar";

export const Blog = () => {
  return (
    <div>
      <Navbar />
      <Part1 />
      <Part2 />
      <Part3 />
      <Part4 />
      <Part5 />
      <Part6 />
      <Footer />
    </div>
  );
};
